import http from 'core/http-common'
import {
  IFilteredPoolVehicleList,
  IGetPoolVehicleTimeTableReq,
  IPoolVehicleListReq,
  IPoolVehicleTimeTableList,
  ISavePoolVehicleReservationReq,
  GearFuelTypeOptions,
} from 'types/PoolVehicleType'

class PoolVehicleService {
  getVehicleFuelTypes() {
    return http.get<GearFuelTypeOptions[]>('PoolVehicle/GetFuelTypes')
  }

  getVehicleGearTypes() {
    return http.get<GearFuelTypeOptions[]>('PoolVehicle/GetGearTypes')
  }

  getPoolVehicleDetailByLocationId(locationId: number) {
    return http.get(`PoolVehicleService/GetByLocationId?locationId=${locationId}`)
  }

  getPoolVehicleLocations() {
    return http.get<any>(`PoolVehicleService/GetLocationList`)
  }

  getPoolVehicleFilteredList(data: IPoolVehicleListReq) {
    return http.post<IFilteredPoolVehicleList[]>(`PoolVehicle/GetFilteredList`, data)
  }

  getPoolVehicleTimeTableList(data: IGetPoolVehicleTimeTableReq) {
    return http.post<IPoolVehicleTimeTableList[]>(`PoolVehicleReservation/GetTimeTableList`, data)
  }

  savePoolVehicleReservation(data: ISavePoolVehicleReservationReq) {
    return http.post('PoolVehicleReservation/SaveReservation', data)
  }

  deletePoolVehicleReservation(data: any) {
    return http.post('PoolVehicleReservation/DeleteReservation', data)
  }
}

export default new PoolVehicleService()
